/* eslint-disable prefer-const */
import { Component, forwardRef, OnChanges, OnInit } from '@angular/core';

import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';
import { MessageService } from 'primeng/api';
import { LocalizationService } from '../../../../../Core/Localization/services/localization.service';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { BlockDisplayTypeEnum } from '../../../enums/block-display-type.enum';
import { ImageSettingsFieldComponent } from './image-settings-field.component';

@Component({
    selector: 'agpr-chart-settings-field',
    templateUrl: './image-settings-field.component.html',
    styleUrls: ['./image-settings-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => ImageSettingsFieldComponent)
        }
    ],
    standalone: false
})
export class BriefingChartSettingsFieldComponent extends ImageSettingsFieldComponent implements OnInit, OnChanges {

    constructor(
        public messageService: MessageService,
        public localizationService: LocalizationService,
        public coreDialogService: CoreDialogService
    ) {
        super(messageService, localizationService, coreDialogService);
        this.captionTitle = 'Common.forms.chart.caption';
        this.captionPlaceholderStr = 'Common.forms.chart.enterCaption';
    }
    ngOnInit(): void {
        this.field.enableAltText = this.block?.displayElement.displayType !== BlockDisplayTypeEnum.ONLINE;
    }
}
